// extracted by mini-css-extract-plugin
export default {"close":"osdMOxg nJoGg3s"};